<nav class="tu-nav-footer navbar navbar-expand-lg navbar-light" [attr.aria-label]="'content.footer-links-label' | translate">
  <div class="container">
    <div class="me-auto ms-3">
      <a class="navbar-brand tu-logo-bottom" href="http://www.transunion.ca/" rel="noopener noreferrer" target="_blank"
         [title]="'content.go-to-the-transunion-home-page' | translate">
        <img [alt]="'content.go-to-the-transunion-home-page' | translate" src="../../assets/images/stamp_bottom.png" />
      </a>
      <span class="align-top">{{ 'content.tu-copyright' | translate }}</span>
    </div>
    <ul class="nav align-self-start text-muted me-3 footer-links-column">
      <li>
        <div class="d-flex flex-column">
          <h1 class="support-header">{{ 'content.support' | translate }}</h1>
          <div>{{ 'content.support-phone' | translate }}</div>
          <div>{{ 'content.support-email' | translate }}</div>
        </div>
      </li>
      <li>
        <div class="d-flex flex-column footer-links-column inline-vertical-gap-5">
          <a href="{{ 'content.accessibility-url' | translate }}" target="_blank" [title]="'content.accessibility-title' | translate">
            {{ 'content.accessibility' | translate }} <span class="visually-hidden">{{ 'content.opens-in-new-window' | translate }}</span>
          </a>
          <a href="{{ 'content.privacy-policy-url' | translate }}" target="_blank" [title]="'content.privacy-policy-title' | translate">
            {{ 'content.privacy-policy' | translate }} <span class="visually-hidden">{{ 'content.opens-in-new-window' | translate }}</span>
          </a>
          <a target="_blank" [routerLink]="['/terms']" [title]="'content.terms-title' | translate">
            {{ 'content.terms-of-use' | translate }} <span class="visually-hidden">{{ 'content.opens-in-new-window' | translate }}</span>
          </a>
        </div>
      </li>
      <li>
        <div class="d-flex flex-column footer-links-column inline-vertical-gap-5">
          <a [routerLink]="['/site-map']" [title]="'content.view-the-site-map' | translate">
            {{ 'content.site-map' | translate }}
          </a>
          <a href="3rdpartylicenses.txt" target="_blank" [title]="'content.view-the-3rd-party-licenses' | translate">
            {{ 'content.3rd-party-licenses' | translate }} <span class="visually-hidden">{{ 'content.opens-in-new-window' | translate }}</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
